import { Node_Type, Decoration_Type, NullValue, ButtonData_Type, HTMLData_Source, RichContent } from 'ricos-schema';
import { isObject, has as has$1, merge, isEmpty as isEmpty$1, omit } from 'lodash';
import 'uuid';

const LINK_BUTTON_TYPE = "wix-draft-plugin-link-button";
const ACTION_BUTTON_TYPE = "wix-draft-plugin-action-button";
const DIVIDER_TYPE = "wix-draft-plugin-divider";
const FILE_UPLOAD_TYPE = "wix-draft-plugin-file-upload";
const GALLERY_TYPE = "wix-draft-plugin-gallery";
const GIPHY_TYPE = "wix-draft-plugin-giphy";
const HTML_TYPE = "wix-draft-plugin-html";
const IMAGE_TYPE = "wix-draft-plugin-image";
const IMAGE_TYPE_LEGACY = "IMAGE";
const SPOILER_TYPE = "wix-rich-content-plugin-spoiler";
const COLLAPSIBLE_LIST_TYPE = "wix-rich-content-plugin-collapsible-list";
const LINK_TYPE = "LINK";
const LINK_PREVIEW_TYPE = "wix-draft-plugin-link-preview";
const MAP_TYPE = "wix-draft-plugin-map";
const MENTION_TYPE = "mention";
const APP_EMBED_TYPE = "wix-draft-plugin-vertical-embed";
const VIDEO_TYPE = "wix-draft-plugin-video";
const AUDIO_TYPE = "ricos-audio";
const VIDEO_TYPE_LEGACY = "VIDEO-EMBED";
const POLL_TYPE = "wix-draft-plugin-poll";
const TABLE_TYPE = "wix-rich-content-plugin-table";
const ANCHOR_TYPE = "ANCHOR";
const EMBED_TYPE = "EMBED";
const EXTERNAL = "EXTERNAL";
Node_Type.DIVIDER;
Node_Type.IMAGE;
Node_Type.GALLERY;
Node_Type.FILE;
Node_Type.GIF;
Node_Type.VIDEO;
Node_Type.AUDIO;
Node_Type.LINK_PREVIEW;
Node_Type.EMBED;
Node_Type.POLL;
Node_Type.APP_EMBED;
Node_Type.COLLAPSIBLE_LIST;
Node_Type.COLLAPSIBLE_ITEM;
Node_Type.COLLAPSIBLE_ITEM_TITLE;
Node_Type.COLLAPSIBLE_ITEM_BODY;
Node_Type.HTML;
Node_Type.CODE_BLOCK;
Node_Type.TABLE;
Node_Type.TABLE_ROW;
Node_Type.TABLE_CELL;
const RICOS_NODE_TYPE_TO_DATA_FIELD = {
  [Node_Type.BUTTON]: "buttonData",
  [Node_Type.DIVIDER]: "dividerData",
  [Node_Type.FILE]: "fileData",
  [Node_Type.GALLERY]: "galleryData",
  [Node_Type.GIF]: "gifData",
  [Node_Type.HTML]: "htmlData",
  [Node_Type.IMAGE]: "imageData",
  [Node_Type.COLLAPSIBLE_LIST]: "collapsibleListData",
  [Node_Type.LINK_PREVIEW]: "linkPreviewData",
  [Node_Type.MAP]: "mapData",
  [Node_Type.APP_EMBED]: "appEmbedData",
  [Node_Type.VIDEO]: "videoData",
  [Node_Type.POLL]: "pollData",
  [Node_Type.TABLE]: "tableData",
  [Node_Type.TABLE_CELL]: "tableCellData",
  [Node_Type.PARAGRAPH]: "paragraphData",
  [Node_Type.LIST_ITEM]: "paragraphData",
  [Node_Type.HEADING]: "headingData",
  [Node_Type.CODE_BLOCK]: "codeBlockData",
  [Node_Type.BLOCKQUOTE]: "paragraphData",
  [Node_Type.EMBED]: "embedData",
  [Node_Type.EXTERNAL]: "externalData",
  [Node_Type.AUDIO]: "audioData"
};

function fromEntries(iterable) {
  return [...iterable].reduce((obj, [key, val]) => {
    obj[key] = val;
    return obj;
  }, {});
}

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
const FROM_DRAFT_LIST_TYPE = {
  ["unordered-list-item" /* UnorderedListItem */]: Node_Type.BULLETED_LIST,
  ["ordered-list-item" /* OrderedListItem */]: Node_Type.ORDERED_LIST
};
fromEntries(
  Object.entries(FROM_DRAFT_LIST_TYPE).map(([key, value]) => [value, key])
);
const TO_RICOS_NODE_TYPE = {
  [LINK_BUTTON_TYPE]: Node_Type.BUTTON,
  [ACTION_BUTTON_TYPE]: Node_Type.BUTTON,
  [DIVIDER_TYPE]: Node_Type.DIVIDER,
  [FILE_UPLOAD_TYPE]: Node_Type.FILE,
  [GALLERY_TYPE]: Node_Type.GALLERY,
  [GIPHY_TYPE]: Node_Type.GIF,
  [HTML_TYPE]: Node_Type.HTML,
  [IMAGE_TYPE]: Node_Type.IMAGE,
  [IMAGE_TYPE_LEGACY]: Node_Type.IMAGE,
  [COLLAPSIBLE_LIST_TYPE]: Node_Type.COLLAPSIBLE_LIST,
  [LINK_PREVIEW_TYPE]: Node_Type.LINK_PREVIEW,
  [MAP_TYPE]: Node_Type.MAP,
  [APP_EMBED_TYPE]: Node_Type.APP_EMBED,
  [VIDEO_TYPE]: Node_Type.VIDEO,
  [AUDIO_TYPE]: Node_Type.AUDIO,
  [VIDEO_TYPE_LEGACY]: Node_Type.VIDEO,
  [POLL_TYPE]: Node_Type.POLL,
  [TABLE_TYPE]: Node_Type.TABLE,
  [EMBED_TYPE]: Node_Type.EMBED,
  [EXTERNAL]: Node_Type.EXTERNAL
};
const DUPLICATE_KEYS = [IMAGE_TYPE_LEGACY, VIDEO_TYPE_LEGACY];
fromEntries(
  Object.entries(TO_RICOS_NODE_TYPE).filter(([key]) => !DUPLICATE_KEYS.includes(key)).map(([key, value]) => [value, key])
);
const TO_RICOS_DECORATION_TYPE = {
  BOLD: Decoration_Type.BOLD,
  ITALIC: Decoration_Type.ITALIC,
  UNDERLINE: Decoration_Type.UNDERLINE,
  [SPOILER_TYPE]: Decoration_Type.SPOILER,
  [ANCHOR_TYPE]: Decoration_Type.ANCHOR,
  [MENTION_TYPE]: Decoration_Type.MENTION,
  [LINK_TYPE]: Decoration_Type.LINK,
  [EXTERNAL]: Decoration_Type.EXTERNAL
};
({
  BOLD: { type: Decoration_Type.BOLD, fontWeightValue: 700 },
  NOT_BOLD: { type: Decoration_Type.BOLD, fontWeightValue: 400 },
  ITALIC: { type: Decoration_Type.ITALIC, italicData: true },
  NOT_ITALIC: { type: Decoration_Type.ITALIC, italicData: false },
  UNDERLINE: { type: Decoration_Type.UNDERLINE, underlineData: true },
  NOT_UNDERLINE: { type: Decoration_Type.UNDERLINE, underlineData: false }
});
__spreadValues$2(__spreadValues$2({}, TO_RICOS_NODE_TYPE), TO_RICOS_DECORATION_TYPE);
const FROM_RICOS_DECORATION_TYPE = fromEntries(
  Object.entries(TO_RICOS_DECORATION_TYPE).map(([key, value]) => [value, key])
);
const DRAFT_BLOCK_TYPE_TO_DATA_FIELD = {
  ["unstyled" /* Unstyled */]: "paragraphData",
  ["unordered-list-item" /* UnorderedListItem */]: "paragraphData",
  ["ordered-list-item" /* OrderedListItem */]: "paragraphData",
  ["header-one" /* HeaderOne */]: "headingData",
  ["header-two" /* HeaderTwo */]: "headingData",
  ["header-three" /* HeaderThree */]: "headingData",
  ["header-four" /* HeaderFour */]: "headingData",
  ["header-five" /* HeaderFive */]: "headingData",
  ["header-six" /* HeaderSix */]: "headingData",
  ["code-block" /* CodeBlock */]: "codeBlockData",
  ["blockquote" /* Blockquote */]: "paragraphData"
};
const DRAFT_PLUGIN_TYPE_TO_DATA_FIELD = fromEntries(
  Object.entries(TO_RICOS_NODE_TYPE).map(([key, value]) => [
    key,
    RICOS_NODE_TYPE_TO_DATA_FIELD[value]
  ])
);
const ENTITY_DECORATION_TO_DATA_FIELD = {
  [ANCHOR_TYPE]: "anchorData",
  [LINK_TYPE]: "linkData",
  [MENTION_TYPE]: "mentionData",
  EMOJI_TYPE: "emojiData"
};
const DECORATION_TO_DATA_FIELD = {
  COLOR: "colorData",
  FONT_SIZE: "fontSizeData"
};
const TO_RICOS_DECORATION_DATA_FIELD = __spreadValues$2(__spreadValues$2({}, ENTITY_DECORATION_TO_DATA_FIELD), DECORATION_TO_DATA_FIELD);
__spreadValues$2(__spreadValues$2(__spreadValues$2({}, TO_RICOS_DECORATION_DATA_FIELD), DRAFT_PLUGIN_TYPE_TO_DATA_FIELD), DRAFT_BLOCK_TYPE_TO_DATA_FIELD);

// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.10.0
 */
/**
 * @since 2.0.0
 */
function identity(a) {
    return a;
}
function pipe$1(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch (arguments.length) {
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        default:
            var ret = arguments[0];
            for (var i = 1; i < arguments.length; i++) {
                ret = arguments[i](ret);
            }
            return ret;
    }
}

(undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
// -------------------------------------------------------------------------------------
// Either
// -------------------------------------------------------------------------------------
/** @internal */
var isLeft$1 = function (ma) { return ma._tag === 'Left'; };
/** @internal */
var left$1 = function (e) { return ({ _tag: 'Left', left: e }); };
/** @internal */
var right$1 = function (a) { return ({ _tag: 'Right', right: a }); };
// -------------------------------------------------------------------------------------
// Record
// -------------------------------------------------------------------------------------
/** @internal */
var has = Object.prototype.hasOwnProperty;

/**
 * A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
 *
 * See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
 *
 * @since 2.0.0
 */
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Magma`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse, concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(reverse(N.MagmaSub))(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), 2)
 *
 * @category combinators
 * @since 2.11.0
 */
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the provided `startWith` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(N.MagmaSub)(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), -6)
 *
 * @since 2.11.0
 */
var concatAll$2 = function (M) { return function (startWith) { return function (as) {
    return as.reduce(function (a, acc) { return M.concat(a, acc); }, startWith);
}; }; };

/**
 * If a type `A` can form a `Semigroup` it has an **associative** binary operation.
 *
 * ```ts
 * interface Semigroup<A> {
 *   readonly concat: (x: A, y: A) => A
 * }
 * ```
 *
 * Associativity means the following equality must hold for any choice of `x`, `y`, and `z`.
 *
 * ```ts
 * concat(x, concat(y, z)) = concat(concat(x, y), z)
 * ```
 *
 * A common example of a semigroup is the type `string` with the operation `+`.
 *
 * ```ts
 * import { Semigroup } from 'fp-ts/Semigroup'
 *
 * const semigroupString: Semigroup<string> = {
 *   concat: (x, y) => x + y
 * }
 *
 * const x = 'x'
 * const y = 'y'
 * const z = 'z'
 *
 * semigroupString.concat(x, y) // 'xy'
 *
 * semigroupString.concat(x, semigroupString.concat(y, z)) // 'xyz'
 *
 * semigroupString.concat(semigroupString.concat(x, y), z) // 'xyz'
 * ```
 *
 * *Adapted from https://typelevel.org/cats*
 *
 * @since 2.0.0
 */
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * Always return the first argument.
 *
 * @example
 * import * as S from 'fp-ts/Semigroup'
 *
 * assert.deepStrictEqual(S.first<number>().concat(1, 2), 1)
 *
 * @category instances
 * @since 2.10.0
 */
var first = function () { return ({ concat: identity }); };
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the provided `startWith` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Semigroup'
 * import * as N from 'fp-ts/number'
 *
 * const sum = concatAll(N.SemigroupSum)(0)
 *
 * assert.deepStrictEqual(sum([1, 2, 3]), 6)
 * assert.deepStrictEqual(sum([]), 0)
 *
 * @since 2.10.0
 */
var concatAll$1 = concatAll$2;

(undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};

const updatePrivacyField = (target, isPrivate) => {
  const privacy = typeof isPrivate !== "undefined" ? isPrivate && "private" || "public" : void 0;
  target.privacy = privacy;
};

/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */
function fromPredicate$1(F) {
    return function (predicate, onFalse) { return function (a) {
        return F.fromEither(predicate(a) ? right$1(a) : left$1(onFalse(a)));
    }; };
}

(undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};

(undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};

/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: Array<A>) => Array<B>`.
 * In practice it applies the base function to each element of the array and collects the
 * results in a new array.
 *
 * @example
 * import { map } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (n: number) => n * 2;
 * assert.deepStrictEqual(pipe([1, 2, 3], map(f)), [2, 4, 6]);
 *
 * @category Functor
 * @since 2.0.0
 */
var map$1 = function (f) { return function (fa) { return fa.map(function (a) { return f(a); }); }; };

// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the monoid `empty` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Monoid'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(concatAll(N.MonoidSum)([1, 2, 3]), 6)
 * assert.deepStrictEqual(concatAll(N.MonoidSum)([]), 0)
 *
 * @since 2.10.0
 */
var concatAll = function (M) { return concatAll$1(M)(M.empty); };

/**
 * Test whether a `ReadonlyRecord` is empty.
 *
 * @example
 * import { isEmpty } from "fp-ts/ReadonlyRecord"
 *
 * assert.deepStrictEqual(isEmpty({}), true);
 * assert.deepStrictEqual(isEmpty({ a: 3 }), false);
 * @since 2.5.0
 */
var isEmpty = function (r) {
    for (var k in r) {
        if (has.call(r, k)) {
            return false;
        }
    }
    return true;
};
/**
 * @since 2.5.0
 */
var empty = {};
function getMonoid$1(S) {
    return {
        concat: function (first, second) {
            if (isEmpty(first)) {
                return second;
            }
            if (isEmpty(second)) {
                return first;
            }
            var r = Object.assign({}, first);
            for (var k in second) {
                if (has.call(second, k)) {
                    r[k] = has.call(first, k) ? S.concat(first[k], second[k]) : second[k];
                }
            }
            return r;
        },
        empty: empty
    };
}

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Returns a `Monoid` instance for `Record`s, given a `Semigroup`
 * instance for the base type.
 * The `Monoid` makes the union of two `Record`s comining the
 * overlapping entries with the provided `Semigroup`.
 *
 * @example
 * import { SemigroupSum } from 'fp-ts/number'
 * import { getMonoid } from 'fp-ts/Record'
 *
 * const M = getMonoid(SemigroupSum);
 * assert.deepStrictEqual(M.concat({ foo: 123, bar: 234 }, { foo: 456, baz: 567 }), { foo: 579 , bar: 234, baz: 567 });
 *
 * @category instances
 * @since 2.0.0
 */
var getMonoid = getMonoid$1;

// -------------------------------------------------------------------------------------
// model
// -------------------------------------------------------------------------------------
/**
 * @category destructors
 * @since 2.5.0
 */
function fst$1(ea) {
    return ea[0];
}
/**
 * @category destructors
 * @since 2.5.0
 */
function snd$1(ea) {
    return ea[1];
}

// -------------------------------------------------------------------------------------
// model
// -------------------------------------------------------------------------------------
/**
 * @category destructors
 * @since 2.0.0
 */
var fst = fst$1;
/**
 * @category destructors
 * @since 2.0.0
 */
var snd = snd$1;
// -------------------------------------------------------------------------------------
// type class members
// -------------------------------------------------------------------------------------
/**
 * Map a pair of functions over the two type arguments of the bifunctor.
 *
 * @category Bifunctor
 * @since 2.0.0
 */
var bimap = function (f, g) { return function (fa) { return [g(fst(fa)), f(snd(fa))]; }; };

// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Constructs a new `Either` holding a `Left` value. This usually represents a failure, due to the right-bias of this
 * structure.
 *
 * @category constructors
 * @since 2.0.0
 */
var left = left$1;
/**
 * Constructs a new `Either` holding a `Right` value. This usually represents a successful value due to the right bias
 * of this structure.
 *
 * @category constructors
 * @since 2.0.0
 */
var right = right$1;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.0.0
 */
var URI = 'Either';
/**
 * Semigroup returning the left-most non-`Left` value. If both operands are `Right`s then the inner values are
 * concatenated using the provided `Semigroup`
 *
 * @example
 * import { getSemigroup, left, right } from 'fp-ts/Either'
 * import { SemigroupSum } from 'fp-ts/number'
 *
 * const S = getSemigroup<string, number>(SemigroupSum)
 * assert.deepStrictEqual(S.concat(left('a'), left('b')), left('a'))
 * assert.deepStrictEqual(S.concat(left('a'), right(2)), right(2))
 * assert.deepStrictEqual(S.concat(right(1), left('b')), right(1))
 * assert.deepStrictEqual(S.concat(right(1), right(2)), right(3))
 *
 * @category instances
 * @since 2.0.0
 */
var getSemigroup = function (S) { return ({
    concat: function (x, y) { return (isLeft(y) ? x : isLeft(x) ? y : right(S.concat(x.right, y.right))); }
}); };
/**
 * @category instance operations
 * @since 2.0.0
 */
var map = function (f) { return function (fa) {
    return isLeft(fa) ? fa : right(f(fa.right));
}; };
/**
 * @category instances
 * @since 2.10.0
 */
var FromEither = {
    URI: URI,
    fromEither: identity
};
/**
 * @example
 * import { fromPredicate, left, right } from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     1,
 *     fromPredicate(
 *       (n) => n > 0,
 *       () => 'error'
 *     )
 *   ),
 *   right(1)
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     -1,
 *     fromPredicate(
 *       (n) => n > 0,
 *       () => 'error'
 *     )
 *   ),
 *   left('error')
 * )
 *
 * @category constructors
 * @since 2.0.0
 */
var fromPredicate = 
/*#__PURE__*/
fromPredicate$1(FromEither);
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * Returns `true` if the either is an instance of `Left`, `false` otherwise.
 *
 * @category refinements
 * @since 2.0.0
 */
var isLeft = isLeft$1;
// -------------------------------------------------------------------------------------
// destructors
// -------------------------------------------------------------------------------------
/**
 * Less strict version of [`match`](#match).
 *
 * @category destructors
 * @since 2.10.0
 */
var matchW = function (onLeft, onRight) { return function (ma) {
    return isLeft(ma) ? onLeft(ma.left) : onRight(ma.right);
}; };
/**
 * Takes two functions and an `Either` value, if the value is a `Left` the inner value is applied to the first function,
 * if the value is a `Right` the inner value is applied to the second function.
 *
 * @example
 * import { match, left, right } from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 *
 * function onLeft(errors: Array<string>): string {
 *   return `Errors: ${errors.join(', ')}`
 * }
 *
 * function onRight(value: number): string {
 *   return `Ok: ${value}`
 * }
 *
 * assert.strictEqual(
 *   pipe(
 *     right(1),
 *     match(onLeft, onRight)
 *   ),
 *   'Ok: 1'
 * )
 * assert.strictEqual(
 *   pipe(
 *     left(['error 1', 'error 2']),
 *     match(onLeft, onRight)
 *   ),
 *   'Errors: error 1, error 2'
 * )
 *
 * @category destructors
 * @since 2.10.0
 */
var match = matchW;
/**
 * Alias of [`match`](#match).
 *
 * @category destructors
 * @since 2.0.0
 */
var fold = match;

const firstRight = (candidate, defaultT, resolvers) => {
  const firstRightSemi = getSemigroup(first());
  const concatFirstRightSemi = concatAll$1(firstRightSemi)(left(defaultT));
  return pipe$1(
    concatFirstRightSemi(
      pipe$1(
        resolvers,
        map$1(
          (r) => pipe$1(
            candidate,
            fromPredicate(r[0], () => defaultT),
            map(r[1])
          )
        )
      )
    ),
    fold(identity, identity)
  );
};

const isBoolValue = (val) => typeof val.boolValue === "boolean";
const isStringValue = (val) => typeof val.stringValue === "string";
const isNumberValue = (val) => typeof val.numberValue === "number";
const isArrayValue = (val) => {
  var _a;
  return isObject(val.listValue) && Array.isArray((_a = val.listValue) == null ? void 0 : _a.values);
};
const isStructValue = (val) => {
  var _a;
  return isObject(val.structValue) && isObject((_a = val.structValue) == null ? void 0 : _a.fields);
};
const isNullValue = (val) => val.nullValue === NullValue.NULL_VALUE;

const mergeJsonMap = getMonoid(first());
const toRecord = ([k, v]) => ({ [k]: v });
const convertStructToJson = (message) => pipe$1(
  message.fields,
  Object.entries,
  map$1(bimap(convertValueToJson, identity)),
  map$1(toRecord),
  concatAll(mergeJsonMap)
);
const convertValueToJson = (message) => firstRight(message, null, [
  [isBoolValue, ({ boolValue }) => boolValue],
  [isNumberValue, ({ numberValue }) => numberValue],
  [isStringValue, ({ stringValue }) => stringValue],
  [isNullValue, () => null],
  [isArrayValue, (m) => convertListToJson(m.listValue || { values: [] })],
  [isStructValue, (m) => convertStructToJson(m.structValue || { fields: {} })]
]);
const convertListToJson = (message) => pipe$1(message.values, map$1(convertValueToJson));

var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __objRest$1 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const parseLink = ({
  url,
  rel,
  target,
  anchor,
  customData
}) => ({
  anchor,
  url,
  rel: rel && Object.entries(rel).flatMap(([key, value]) => value ? key : []).join(" "),
  target: target && "_" + target.toLowerCase(),
  customData
});
const convertVideoData = (data) => {
  var _a, _b;
  const videoSrc = (_a = data.video) == null ? void 0 : _a.src;
  const { src, width, height } = data.thumbnail || {};
  if (videoSrc == null ? void 0 : videoSrc.url) {
    data.src = videoSrc.url;
    data.metadata = { thumbnail_url: src == null ? void 0 : src.url, width, height, title: data.title };
  } else if ((videoSrc == null ? void 0 : videoSrc.id) || (videoSrc == null ? void 0 : videoSrc.custom)) {
    const pathname = (src == null ? void 0 : src.id) || (src == null ? void 0 : src.custom);
    data.src = {
      pathname: (videoSrc == null ? void 0 : videoSrc.id) || (videoSrc == null ? void 0 : videoSrc.custom),
      thumbnail: pathname ? { pathname, width, height } : void 0
    };
  }
  data.duration = (_b = data.video) == null ? void 0 : _b.duration;
  delete data.video;
  delete data.title;
  delete data.thumbnail;
};
const convertAudioData = (data) => {
  var _a, _b, _c, _d;
  const { coverImage } = data;
  if (coverImage) {
    const { width, height } = coverImage;
    const id = (_b = coverImage == null ? void 0 : coverImage.id) != null ? _b : (_a = coverImage == null ? void 0 : coverImage.src) == null ? void 0 : _a.id;
    const file_name = (_d = coverImage == null ? void 0 : coverImage.file_name) != null ? _d : (_c = coverImage == null ? void 0 : coverImage.src) == null ? void 0 : _c.id;
    data.coverImage = {
      id,
      file_name,
      width,
      height
    };
  }
};
const convertExternalData = (data) => {
  const draftData = convertStructToJson(data);
  Object.entries(draftData).forEach(([k, v]) => {
    data[k] = v;
  });
  delete data.fields;
};
const convertDividerData = (data) => {
  var _a, _b, _c;
  data.type = (_a = data.lineStyle) == null ? void 0 : _a.toLowerCase();
  delete data.lineStyle;
  data.config = data.config || {};
  if (has$1(data, "width")) {
    data.config.size = (_b = data.width) == null ? void 0 : _b.toLowerCase();
    delete data.width;
  }
  if (has$1(data, "alignment")) {
    data.config.alignment = (_c = data.alignment) == null ? void 0 : _c.toLowerCase();
    delete data.alignment;
  }
  delete data.containerData;
};
var GalleryLayout = /* @__PURE__ */ ((GalleryLayout2) => {
  GalleryLayout2[GalleryLayout2["COLLAGE"] = 0] = "COLLAGE";
  GalleryLayout2[GalleryLayout2["MASONRY"] = 1] = "MASONRY";
  GalleryLayout2[GalleryLayout2["GRID"] = 2] = "GRID";
  GalleryLayout2[GalleryLayout2["THUMBNAIL"] = 3] = "THUMBNAIL";
  GalleryLayout2[GalleryLayout2["SLIDER"] = 4] = "SLIDER";
  GalleryLayout2[GalleryLayout2["SLIDESHOW"] = 5] = "SLIDESHOW";
  GalleryLayout2[GalleryLayout2["PANORAMA"] = 6] = "PANORAMA";
  GalleryLayout2[GalleryLayout2["COLUMN"] = 7] = "COLUMN";
  GalleryLayout2[GalleryLayout2["MAGIC"] = 8] = "MAGIC";
  GalleryLayout2[GalleryLayout2["FULLSIZE"] = 9] = "FULLSIZE";
  return GalleryLayout2;
})(GalleryLayout || {});
const convertGalleryStyles = (options) => {
  const styles = {};
  has$1(options, "layout.type") && (styles.galleryLayout = parseInt(GalleryLayout[options.layout.type]));
  has$1(options, "layout.horizontalScroll") && (styles.oneRow = options.layout.horizontalScroll);
  has$1(options, "layout.orientation") && (styles.isVertical = options.layout.orientation === "COLUMNS");
  has$1(options, "layout.numberOfColumns") && (styles.numberOfImagesPerRow = options.layout.numberOfColumns);
  has$1(options, "layout.mobileNumberOfColumns") && (styles.m_numberOfImagesPerRow = options.layout.mobileNumberOfColumns);
  has$1(options, "item.targetSize") && (styles.gallerySizePx = options.item.targetSize);
  has$1(options, "item.ratio") && (styles.cubeRatio = options.item.ratio);
  has$1(options, "item.crop") && (styles.cubeType = options.item.crop.toLowerCase());
  has$1(options, "item.spacing") && (styles.imageMargin = options.item.spacing);
  has$1(options, "thumbnails.placement") && (styles.galleryThumbnailsAlignment = options.thumbnails.placement.toLowerCase());
  has$1(options, "thumbnails.spacing") && (styles.thumbnailSpacings = Math.trunc(options.thumbnails.spacing));
  return styles;
};
const convertGalleryItem = (item) => {
  var _a, _b;
  const type = has$1(item, "image") && !isEmpty$1(item.image) ? "image" : "video";
  const {
    src: { url },
    height,
    width
  } = ((_a = item[type]) == null ? void 0 : _a.media) || { src: {} };
  item.url = url;
  item.metadata = { height, width, type };
  has$1(item, "title") && (item.metadata.title = item.title);
  has$1(item, "altText") && (item.metadata.altText = item.altText);
  if (has$1(item, "video.thumbnail")) {
    const {
      src: { url: url2 },
      height: height2,
      width: width2
    } = item.video.thumbnail;
    item.metadata.poster = { url: url2, height: height2, width: width2 };
  }
  ((_b = item.image) == null ? void 0 : _b.link) && (item.metadata.link = parseLink(item.image.link));
  delete item.video;
  delete item.image;
  delete item.title;
  delete item.altText;
  return item;
};
const convertGalleryData = (data) => {
  has$1(data, "items") && (data.items = data.items.map((item) => convertGalleryItem(item)));
  has$1(data, "options") && (data.styles = convertGalleryStyles(data.options));
  delete data.options;
};
const convertImageData = (data) => {
  var _a, _b;
  const { link, config, image, altText, caption } = data;
  const { src, width, height } = image || {};
  const id = (src == null ? void 0 : src.id) || (src == null ? void 0 : src.custom);
  data.src = id ? { id, file_name: id, width, height } : { url: src == null ? void 0 : src.url, source: "static", width, height };
  const links = __spreadValues$1(__spreadValues$1({}, (link == null ? void 0 : link.anchor) ? { anchor: link == null ? void 0 : link.anchor } : {}), link ? { link: parseLink(link) } : {});
  if ((_a = links.link) == null ? void 0 : _a.customData) {
    const parsedCustomData = parseLinkCustomData((_b = links.link) == null ? void 0 : _b.customData);
    merge(links.link, parsedCustomData);
    if (!parsedCustomData.customData) {
      delete links.link.customData;
    }
  }
  data.config = __spreadValues$1(__spreadValues$1({}, config || {}), links);
  data.metadata = typeof altText === "string" || typeof caption === "string" ? {
    caption,
    alt: altText
  } : void 0;
  delete data.image;
  delete data.link;
  delete data.caption;
  delete data.altText;
};
const convertGIFData = (data) => {
  const { original = {}, downsized = {}, height, width } = data;
  data.gif = {
    originalUrl: original.gif,
    originalMp4: original.mp4,
    stillUrl: original.still,
    downsizedUrl: downsized.gif,
    downsizedSmallMp4: downsized.mp4,
    downsizedStillUrl: downsized.still,
    height,
    width
  };
  delete data.original;
  delete data.downsized;
  delete data.height;
  delete data.width;
};
const convertPollData = (data) => {
  var _a;
  has$1(data, "layout.poll.type") && (data.layout.poll.type = data.layout.poll.type.toLowerCase());
  has$1(data, "layout.poll.direction") && (data.layout.poll.direction = data.layout.poll.direction.toLowerCase());
  if (has$1(data, "layout.options")) {
    data.layout.option = data.layout.options;
    delete data.layout.options;
  }
  if (has$1(data, "design")) {
    const { poll = {}, options = {} } = data.design;
    const { background, borderRadius } = poll;
    const getBackground = (background2) => {
      var _a2, _b, _c, _d, _e, _f, _g;
      return (background2 == null ? void 0 : background2.gradient) ? {
        angle: (_a2 = background2 == null ? void 0 : background2.gradient) == null ? void 0 : _a2.angle,
        start: (_b = background2 == null ? void 0 : background2.gradient) == null ? void 0 : _b.startColor,
        end: (_c = background2 == null ? void 0 : background2.gradient) == null ? void 0 : _c.lastColor
      } : ((_e = (_d = background2 == null ? void 0 : background2.color) == null ? void 0 : _d.charAt) == null ? void 0 : _e.call(_d, 0)) === "#" ? background2 == null ? void 0 : background2.color : (_g = (_f = background2 == null ? void 0 : background2.image) == null ? void 0 : _f.src) == null ? void 0 : _g.url;
    };
    data.design = {
      poll: {
        backgroundType: (_a = background == null ? void 0 : background.type) == null ? void 0 : _a.toLowerCase(),
        background: getBackground(background),
        borderRadius: `${borderRadius}px`
      },
      option: { borderRadius: `${options.borderRadius}px` }
    };
  }
  has$1(data, "poll.pollId") && (data.poll.id = data.poll.pollId);
  delete data.poll.pollId;
  has$1(data, "poll.creatorId") && (data.poll.createdBy = data.poll.creatorId);
  delete data.poll.creatorId;
  has$1(data, "poll.image.src.url") && (data.poll.mediaId = data.poll.image.src.url);
  delete data.poll.image;
  has$1(data, "poll.options") && (data.poll.options = data.poll.options.map((_b) => {
    var _c = _b, { image } = _c, rest = __objRest$1(_c, ["image"]);
    var _a2;
    return __spreadValues$1({
      mediaId: (_a2 = image == null ? void 0 : image.src) == null ? void 0 : _a2.url
    }, rest);
  }));
  if (has$1(data, "poll.settings")) {
    const { showVotesCount, showVoters, permissions } = data.poll.settings;
    const { view, vote, allowMultipleVotes } = permissions || {};
    const getResultsVisibility = (view2) => view2 === "EVERYONE" ? "ALWAYS" : view2 === "VOTERS" ? "VOTERS_ONLY" : "ONLY_ME";
    data.poll.settings = {
      resultsVisibility: getResultsVisibility(view),
      multipleVotes: allowMultipleVotes,
      voteRole: vote,
      votersDisplay: showVoters,
      votesDisplay: showVotesCount
    };
  }
  data.config.size = "large";
  data.config.width = "full-width";
};
const convertAppEmbedData = (data) => {
  const { type, itemId, name, image, url, bookingData, eventData, imageSrc } = data;
  const { src, width, height } = image || {};
  data.type = type.toLowerCase();
  const selectedProduct = __spreadValues$1(__spreadValues$1({
    id: itemId,
    name,
    imageSrc: (src == null ? void 0 : src.url) || imageSrc,
    pageUrl: url
  }, bookingData || {}), eventData || {});
  width && (selectedProduct.imageWidth = width);
  height && (selectedProduct.imageHeight = height);
  data.selectedProduct = selectedProduct;
  delete data.id;
  delete data.itemId;
  delete data.name;
  delete data.imageSrc;
  delete data.image;
  delete data.url;
  bookingData && delete data.bookingData;
  eventData && delete data.eventData;
};
const convertLinkPreviewData = (data) => {
  if (data.thumbnailUrl) {
    data.thumbnail_url = data.thumbnailUrl;
    delete data.thumbnailUrl;
  }
  if (data.link) {
    data.config.link = parseLink(data.link);
    delete data.link;
  }
};
const convertFileData = (data) => {
  const { url, id, custom, private: isPrivate } = data.src || {};
  data.url = url;
  data.id = id || custom;
  updatePrivacyField(data, isPrivate);
  delete data.src;
};
const convertButtonData = (data) => {
  const { link, text, type, styles } = data;
  const { colors, border } = styles || {};
  const { width, radius } = border || {};
  const convertedLink = type === ButtonData_Type.LINK && link ? parseLink(link) : {};
  data.button = {
    settings: __spreadValues$1({
      buttonText: text
    }, convertedLink),
    design: {
      borderRadius: radius,
      borderWidth: width,
      background: colors == null ? void 0 : colors.background,
      color: colors == null ? void 0 : colors.text,
      borderColor: colors == null ? void 0 : colors.border
    }
  };
  delete data.link;
  delete data.text;
  delete data.type;
  delete data.styles;
};
const convertHTMLData = (data) => {
  var _a;
  const { html, url, source } = data;
  const srcType = typeof html === "string" ? "html" : "url";
  data.srcType = srcType;
  data.src = (_a = html || url) != null ? _a : "";
  source === HTMLData_Source.ADSENSE && (data.config.isAdsense = true);
  delete data.source;
  delete data[srcType];
};
const convertMapData = (data) => {
  const {
    draggable,
    marker,
    streetViewControl,
    zoomControl,
    locationName,
    viewModeControl,
    initialZoom,
    mapType
  } = data.mapSettings;
  data.mapSettings.isDraggingAllowed = draggable;
  data.mapSettings.isMarkerShown = marker;
  data.mapSettings.isStreetViewControlShown = streetViewControl;
  data.mapSettings.isZoomControlShown = zoomControl;
  data.mapSettings.locationDisplayName = locationName;
  data.mapSettings.zoom = initialZoom;
  data.mapSettings.mode = mapType == null ? void 0 : mapType.toLowerCase();
  delete data.mapSettings.draggable;
  delete data.mapSettings.marker;
  delete data.mapSettings.streetViewControl;
  delete data.mapSettings.zoomControl;
  delete data.mapSettings.locationName;
  delete data.mapSettings.initialZoom;
  delete data.mapSettings.mapType;
  if (viewModeControl) {
    data.mapSettings.isViewControlShown = viewModeControl;
    delete data.mapSettings.viewModeControl;
  }
};
const convertEmbedData = (data) => {
  data.config = __spreadProps$1(__spreadValues$1({}, (data == null ? void 0 : data.config) || {}), {
    alignment: "center",
    size: "content",
    link: { url: data.src, target: "_blank", rel: "noopener" }
  });
  const { html, thumbnailUrl, title, description } = data.oembed;
  data.html = html;
  thumbnailUrl && (data.thumbnail_url = thumbnailUrl);
  typeof title === "string" && (data.title = title);
  description && (data.description = description);
  delete data.oembed;
  delete data.src;
};
const parseLinkCustomData = (customData) => {
  try {
    return { customData: JSON.parse(customData) };
  } catch (e) {
    console.error("failed to parse customData", customData);
    return { customData };
  }
};
({
  [Node_Type.VIDEO]: convertVideoData,
  [Node_Type.AUDIO]: convertAudioData,
  [Node_Type.DIVIDER]: convertDividerData,
  [Node_Type.FILE]: convertFileData,
  [Node_Type.GIF]: convertGIFData,
  [Node_Type.IMAGE]: convertImageData,
  [Node_Type.POLL]: convertPollData,
  [Node_Type.APP_EMBED]: convertAppEmbedData,
  [Node_Type.LINK_PREVIEW]: convertLinkPreviewData,
  [Node_Type.BUTTON]: convertButtonData,
  [Node_Type.HTML]: convertHTMLData,
  [Node_Type.MAP]: convertMapData,
  [Node_Type.EMBED]: convertEmbedData,
  [Node_Type.GALLERY]: convertGalleryData,
  [Node_Type.EXTERNAL]: convertExternalData
});

({
  [Decoration_Type.BOLD]: ({ fontWeightValue }) => {
    return fontWeightValue ? { "font-weight": fontWeightValue >= 700 ? "bold" : "normal" } : {};
  },
  [Decoration_Type.ITALIC]: ({ italicData }) => {
    return typeof italicData !== "undefined" ? { "font-style": italicData ? "italic" : "normal" } : {};
  },
  [Decoration_Type.UNDERLINE]: ({ underlineData }) => {
    return typeof underlineData !== "undefined" ? {
      "text-decoration": underlineData ? "underline" : "none"
    } : {};
  },
  [Decoration_Type.FONT_SIZE]: ({ fontSizeData }) => {
    return fontSizeData ? { "font-size": fontSizeData.value + (fontSizeData.unit.toLowerCase() || "px") } : {};
  },
  [Decoration_Type.COLOR]: ({ colorData }) => {
    const { foreground, background } = colorData;
    const colors = {};
    foreground && (colors["color"] = foreground);
    background && (colors["background-color"] = background);
    return colors;
  }
});

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const pipe = (arg, ...fns) => {
  return fns.reduce((v, fn) => fn(v), arg);
};
const mergeTextNodes = (nodes) => {
  let length = 0;
  return nodes.reduce(
    ({ text, decorationMap }, currNode) => {
      let accText = text;
      if (currNode.textData) {
        const { text: currText, decorations: currDecorations } = currNode.textData;
        const textLength = Array.from(currText).length;
        accText += currText;
        if (currDecorations) {
          convertDecorationTypes(currDecorations).forEach((decoration) => {
            if (!decorationMap[decoration.type]) {
              decorationMap[decoration.type] = [];
            }
            decorationMap[decoration.type] = [
              ...decorationMap[decoration.type],
              __spreadProps(__spreadValues({}, decoration), {
                start: length,
                end: length + textLength
              })
            ];
          });
        }
        length += textLength;
      }
      return { text: accText, decorationMap };
    },
    { text: "", decorationMap: {} }
  );
};
const getParagraphNode = (node) => {
  if (node.nodes[0].type === Node_Type.PARAGRAPH) {
    return node.nodes[0];
  } else {
    throw Error(`Expected a paragraph node but found ${node.nodes[0].type}`);
  }
};
const convertDecorationTypes = (decorations) => decorations.flatMap(
  (decoration) => pipe(
    decoration,
    toDraftDecorationType,
    convertFontSize,
    convertFontWeight,
    convertItalic,
    convertUnderline,
    splitColorDecoration
  )
);
const toDraftDecorationType = (decoration) => {
  const type = omit(FROM_RICOS_DECORATION_TYPE, [
    Decoration_Type.BOLD,
    Decoration_Type.ITALIC,
    Decoration_Type.UNDERLINE
  ])[decoration == null ? void 0 : decoration.type];
  return type ? __spreadProps(__spreadValues({}, decoration), { type }) : decoration;
};
const splitColorDecoration = (_a) => {
  var _b = _a, {
    colorData
  } = _b, decoration = __objRest(_b, [
    "colorData"
  ]);
  if (!colorData) {
    return decoration;
  }
  const { foreground, background } = colorData;
  return [foreground && { FG: foreground }, background && { BG: background }].filter((x) => x).map((type) => __spreadProps(__spreadValues({}, decoration), { type: JSON.stringify(type) }));
};
const convertFontSize = (_c) => {
  var _d = _c, {
    fontSizeData
  } = _d, decoration = __objRest(_d, [
    "fontSizeData"
  ]);
  var _a, _b;
  return fontSizeData ? __spreadProps(__spreadValues({}, decoration), {
    type: JSON.stringify({
      "font-size": ((_a = fontSizeData.value) == null ? void 0 : _a.toString()) + (((_b = fontSizeData.unit) == null ? void 0 : _b.toLowerCase()) || "px")
    })
  }) : decoration;
};
const convertFontWeight = (_e) => {
  var _f = _e, {
    fontWeightValue
  } = _f, decoration = __objRest(_f, [
    "fontWeightValue"
  ]);
  return decoration.type === Decoration_Type.BOLD ? __spreadProps(__spreadValues({}, decoration), {
    type: !fontWeightValue || fontWeightValue >= 700 ? "BOLD" : "NOT_BOLD"
  }) : decoration;
};
const convertItalic = (_g) => {
  var _h = _g, {
    italicData
  } = _h, decoration = __objRest(_h, [
    "italicData"
  ]);
  const isItalicDataUndefined = typeof italicData === "undefined";
  return decoration.type === Decoration_Type.ITALIC ? __spreadProps(__spreadValues({}, decoration), {
    type: isItalicDataUndefined || italicData ? "ITALIC" : "NOT_ITALIC"
  }) : decoration;
};
const convertUnderline = (_i) => {
  var _j = _i, {
    underlineData
  } = _j, decoration = __objRest(_j, [
    "underlineData"
  ]);
  const isUnerlineDataUndefined = typeof underlineData === "undefined";
  return decoration.type === Decoration_Type.UNDERLINE ? __spreadProps(__spreadValues({}, decoration), {
    type: isUnerlineDataUndefined || underlineData ? "UNDERLINE" : "NOT_UNDERLINE"
  }) : decoration;
};

const parseTextNodes = (node, addTextLinks) => {
  const {
    text,
    decorationMap: { [LINK_TYPE]: linkDecorations }
  } = mergeTextNodes(node.nodes);
  const finalText = addTextLinks ? addLinksToText(text, linkDecorations) : text;
  return removeTrailingNewLine(finalText);
};
const listNodeToLines = (listNode, addTextLinks, depth = 0) => listNode.nodes.flatMap((listItemNode, listItemIndex) => {
  return listItemNode.nodes.flatMap((listItemNodeChild, index) => {
    if (listItemNodeChild.type === Node_Type.PARAGRAPH) {
      const text = parseTextNodes(listItemNodeChild, addTextLinks);
      if (index === 0) {
        if (listNode.type === Node_Type.ORDERED_LIST) {
          return "   ".repeat(depth) + (listItemIndex + 1) + ". " + text;
        }
        if (listNode.type === Node_Type.BULLETED_LIST) {
          return "   ".repeat(depth) + " \u2022 " + text;
        }
      }
      return "   ".repeat(depth + 1) + text;
    }
    if (listItemNodeChild.type === Node_Type.ORDERED_LIST || listItemNodeChild.type === Node_Type.BULLETED_LIST) {
      return listNodeToLines(listItemNodeChild, addTextLinks, depth + 1);
    }
    return [];
  });
});
const parseListNode = (node, delimiter, addTextLinks) => listNodeToLines(node, addTextLinks).join(delimiter);
const addLinksToText = (text, linkDecorations = []) => linkDecorations.sort((a, b) => a.end - b.end).reduce(
  (newText, link) => {
    var _a, _b;
    return insertInText(
      newText,
      link.end + newText.length - text.length + 1,
      `(${(_b = (_a = link.linkData) == null ? void 0 : _a.link) == null ? void 0 : _b.url})`
    );
  },
  text
);
const insertInText = (text, pos, insertedText) => text.substring(0, pos) + insertedText + text.substring(pos);
const removeTrailingNewLine = (text) => text.endsWith("\n") ? text.substring(0, text.length - 1) : text;
function* parseImage({ imageData }, delimiter) {
  const { caption } = imageData || {};
  const { src } = (imageData == null ? void 0 : imageData.image) || {};
  const id = (src == null ? void 0 : src.id) || (src == null ? void 0 : src.custom);
  const url = yield {
    command: "getImageUrl",
    data: `https://static.wixstatic.com/media/${id == null ? void 0 : id.replace("media/", "")}`
  };
  return [caption, url].filter(Boolean).join(delimiter);
}
const getDefaultVideoUrl = (fileId) => `https://video.wixstatic.com/${fileId}`;
const getDefaultAudioUrl = (fileId) => `https://static.wixstatic.com/${fileId}`;
function* parseVideo({ videoData }, delimiter) {
  const { video, title } = videoData || {};
  const { custom, id, url } = (video == null ? void 0 : video.src) || {};
  const vidId = id || custom;
  const vidUrl = url || "";
  let videoUrl;
  if (vidId) {
    videoUrl = yield {
      command: "getVideoUrl",
      data: vidId
    };
  } else {
    videoUrl = yield {
      command: "getVideoEmbeddedUrl",
      data: vidUrl
    };
  }
  return title ? title + delimiter + videoUrl : videoUrl;
}
function* parseAudio({ audioData }, delimiter) {
  const { audio, name } = audioData || {};
  const { id, url } = (audio == null ? void 0 : audio.src) || {};
  let audioUrl = url || "";
  if (id) {
    audioUrl = yield {
      command: "getAudioUrl",
      data: id
    };
  }
  return name ? name + delimiter + audioUrl : audioUrl;
}
function* parseGiphy({ gifData }) {
  var _a;
  let gifUrl = ((_a = gifData == null ? void 0 : gifData.original) == null ? void 0 : _a.gif) || "";
  if (gifUrl) {
    gifUrl = yield {
      command: "getGifUrl",
      data: gifUrl
    };
  }
  return gifUrl;
}
const parseMap = ({ mapData }) => {
  const { address } = (mapData == null ? void 0 : mapData.mapSettings) || {};
  return address || "";
};
const parseAppEmbed = ({ appEmbedData }, delimiter) => {
  const { url, name } = appEmbedData || {};
  return [name, url].filter(Boolean).join(delimiter);
};
const parseLinkPreview = ({ linkPreviewData }) => {
  const { url } = (linkPreviewData == null ? void 0 : linkPreviewData.link) || {};
  return url || "";
};
const parseEmbed = ({ embedData }, delimiter) => {
  var _a;
  return [(_a = embedData == null ? void 0 : embedData.oembed) == null ? void 0 : _a.title, embedData == null ? void 0 : embedData.src].filter(Boolean).join(delimiter);
};

function* parseCollapsible(node, delimiter) {
  const collapsibleTextNodes = [];
  for (const child of node.nodes) {
    collapsibleTextNodes.push(
      [yield* toPlainTextBase(child.nodes[0]), yield* toPlainTextBase(child.nodes[1])].join(
        delimiter
      )
    );
  }
  return collapsibleTextNodes.join(delimiter);
}
function* toPlainTextBase(content, delimiter = "\n", addLinksToText = true) {
  const ricosContent = RichContent.fromJSON(content);
  const { nodes } = ricosContent;
  let plainText = "";
  function* parseNodes(index = 0) {
    const node = nodes[index];
    if (node) {
      if (index > 0) {
        plainText += delimiter;
      }
      switch (node.type) {
        case Node_Type.CODE_BLOCK:
        case Node_Type.PARAGRAPH:
        case Node_Type.HEADING:
          plainText += parseTextNodes(node, addLinksToText);
          break;
        case Node_Type.BLOCKQUOTE:
          plainText += parseTextNodes(getParagraphNode(node), addLinksToText);
          break;
        case Node_Type.ORDERED_LIST:
        case Node_Type.BULLETED_LIST:
          plainText += parseListNode(node, delimiter, addLinksToText);
          break;
        case Node_Type.GIF:
          plainText += yield* parseGiphy(node);
          break;
        case Node_Type.MAP:
          plainText += parseMap(node);
          break;
        case Node_Type.APP_EMBED:
          plainText += parseAppEmbed(node, delimiter);
          break;
        case Node_Type.LINK_PREVIEW:
          plainText += parseLinkPreview(node);
          break;
        case Node_Type.EMBED:
          plainText += parseEmbed(node);
          break;
        case Node_Type.IMAGE:
          plainText += yield* parseImage(node, delimiter);
          break;
        case Node_Type.VIDEO:
          plainText += yield* parseVideo(node, delimiter);
          break;
        case Node_Type.AUDIO:
          plainText += yield* parseAudio(node, delimiter);
          break;
        case Node_Type.COLLAPSIBLE_LIST:
          plainText += yield* parseCollapsible(node, delimiter);
          break;
      }
      yield* parseNodes(index + 1);
    }
  }
  yield* parseNodes();
  return plainText;
}

const toPlainTextSync = (content, options = {}) => {
  var _a;
  const gen = toPlainTextBase(content, options.delimiter, options.addLinksToText);
  let next = gen.next();
  while (!next.done) {
    switch (next.value.command) {
      case "getImageUrl": {
        const url = options.urlShortener ? (_a = options.urlShortener) == null ? void 0 : _a.call(options, next.value.data) : next.value.data;
        next = gen.next(url);
        break;
      }
      case "getVideoUrl": {
        const url = options.getVideoUrl ? options.getVideoUrl(next.value.data) : getDefaultVideoUrl(next.value.data);
        next = gen.next(url);
        break;
      }
      case "getVideoEmbeddedUrl": {
        const url = options.getVideoEmbeddedUrl ? options.getVideoEmbeddedUrl(next.value.data) : next.value.data;
        next = gen.next(url);
        break;
      }
      case "getAudioUrl": {
        const url = options.getAudioUrl ? options.getAudioUrl(next.value.data) : getDefaultAudioUrl(next.value.data);
        next = gen.next(url);
        break;
      }
      case "getGifUrl": {
        const url = options.getGifUrl ? options.getGifUrl(next.value.data) : next.value.data;
        next = gen.next(url);
        break;
      }
      default:
        return "";
    }
  }
  return next.value;
};

export { toPlainTextSync };
